module.exports = __webpack_public_path__ + "img/health9_7-9-2021.db8dee6e.jpg";